import { Box } from "@mui/material";
import { GREY } from "../style/theme";

export function UFieldset(props) {
    const { title } = props;

    return <Box component="fieldset" {...props} sx={{
        "legend": { color: GREY[700], fontSize: 12 },
        border: '1px solid ' + GREY[500],
        borderRadius: 1,
        ...props.sx,
    }}>
        <legend>{title}</legend>
        {props.children}
    </Box>
}